import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

import AdobeAnalytics from "../../images/website image/work image/Adobe Analytics.png";
import InsuranceProduct from "../../images/website image/work image/Insurance Product.png";
import AdobeExperienceManagement from "../../images/website image/work image/Adobe Experience  management.png";
import FleetManagement from "../../images/website image/work image/fleet management.png";
import SaasLifecycleManagement from "../../images/website image/work image/saas lifecycle management.png";
import CloudTechnology from "../../images/website image/work image/svd cloud framewok.png";

const CaseStudiesComponent = () => {
  const caseStudies = [
    {
      title: "How Astemo is streamlining SDV innovation with cloud technology",
      description: "Discover how ProvaanTech is transforming Hitachi Astemo’s SDV development with cloud-based solutions, driving innovation, efficiency, and cost savings.",
      image: CloudTechnology,
      category: "Cloud & SDV",
      link: "#"
    },
    {
      title: "Fleet Management R&D Lab and Data Platform",
      description: "Explore a fleet management leader’s digital transformation story and learn how they use technology to maximize asset use and driver safety.",
      image: FleetManagement,
      category: "IoT & Analytics",
      link: "#"
    },
    {
      title: "How Reqtest Grew 20% with R&D Partner ProvaanTech",
      description: "Explore how Reqtest, an application lifecycle management SaaS company, transformed its R&D department and achieved remarkable growth through its partnership with ProvaanTech.",
      image: SaasLifecycleManagement,
      category: "SaaS R&D",
      link: "#"
    },
    {
      title: "Adobe Experience Manager Case Study: Telecom Self-Service Portal Implementation",
      description: "When a leading telecommunications carrier needed to modernize its self-service client portal, ProvaanTech made it happen with Adobe Experience Manager.",
      image: AdobeExperienceManagement,
      category: "Enterprise CMS",
      link: "#"
    },
    {
      title: "Adobe Analytics & AEM Case Study: 865% Growth in Omni-channel Shopping Sales",
      description: "See how Adobe Experience Manager and Analytics implementations changed the game for one of the largest department stores in the U.S., driving revenue growth and customer satisfaction.",
      image: AdobeAnalytics,
      category: "Retail Tech",
      link: "#"
    },
    {
      title: "Insurance Product Engineering & Services",
      description: "A case study on how Insurity transformed its offerings, upgraded core architecture, and successfully streamlined product engineering services.",
      image: InsuranceProduct,
      category: "Fintech & Insurtech",
      link: "#"
    }
  ];

  return (
    <div className="w-full px-6 sm:px-8 lg:px-12 mx-auto max-w-7xl">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
        <div>
          <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight">
            Featured Case Studies
          </h2>
          <p className="text-slate-500 mt-2 max-w-xl">
            Explore how we help global leaders engineer software, automate workflows, and drive digital agility.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10">
        {caseStudies.map(({ title, description, image, category, link }, index) => (
          <div 
            key={index}
            className="group flex flex-col bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-slate-100 hover:-translate-y-1.5"
          >
            {/* Card Image Area with Zoom */}
            <div className="relative overflow-hidden aspect-video w-full bg-slate-100">
              <img 
                src={image} 
                alt={title} 
                className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-500" 
              />
              {/* Category Pill Tag */}
              <span className="absolute top-4 left-4 inline-block px-3 py-1 text-xs font-semibold text-white bg-slate-900/80 backdrop-blur-md rounded-full shadow-sm">
                {category}
              </span>
            </div>

            {/* Card Content Area */}
            <div className="flex flex-col flex-grow p-6 sm:p-7">
              {/* Title using CSS line clamp for alignment */}
              <h3 className="mb-3 text-lg font-bold text-slate-800 line-clamp-2 leading-snug group-hover:text-blue-600 transition-colors duration-200" title={title}>
                {title}
              </h3>
              
              {/* Description using CSS line clamp for alignment */}
              <p className="mb-6 text-sm text-slate-600 line-clamp-3 leading-relaxed flex-grow">
                {description}
              </p>

              {/* Action Link Footer */}
              <div className="pt-4 border-t border-slate-50 mt-auto">
                <a 
                  href={link} 
                  className="inline-flex items-center gap-2 text-sm font-bold text-blue-600 hover:text-blue-800 transition-colors group-hover:translate-x-1 duration-200"
                >
                  <span>Learn More</span>
                  <FaArrowRight className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseStudiesComponent;
